import React from 'react';
import { SUPER_ADMIN_ACCESS, ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))
const BeaconBoard = React.lazy(() => import('pages/beacon/BeaconBoard'))
const BeaconBoardDetail = React.lazy(() => import('pages/beacon/BeaconBoardDetail')) 
const BeaconBoardWrite = React.lazy(() => import('pages/beacon/BeaconBoardWrite')) 
const BeaconBoardModify = React.lazy(() => import('pages/beacon/BeaconBoardModify')) 
const MobileBoard = React.lazy(() => import('pages/beacon/MoblieBoard'))
const MobileBoardModify = React.lazy(() => import('pages/beacon/MobileBoardModify')) 

const PF = '/terminal'
const RoutesTerminal = [
    
    { path: `${PF}`, exact: true, name: '비콘단말기 관리' },
    { path: `${PF}/beacon`, exact: true, name: '비콘단말기 관리', element: <BeaconBoardDetail />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/beacon/write`, exact: true, name: '작성', element: <BeaconBoardWrite />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/beacon/modify/:NO`, exact: true, name: '수정', element: <BeaconBoardModify />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/mobile`, exact: true, name: '기기변경', element: <MobileBoard />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/mobile/modify/:NO`, exact: true, name: '삭제', element: <MobileBoardModify />, ...ADMIN_ACCESS },

    { path: `${PF}`, exact: true, name: '비콘단말기 관리' },
    { path: `${PF}/company-beacon`, exact: true, name: '비콘단말기 관리', element: <BeaconBoardDetail />, ...ADMIN_ACCESS },
    { path: `${PF}/company-beacon/write`, exact: true, name: '작성', element: <BeaconBoardWrite />, ...ADMIN_ACCESS },
    { path: `${PF}/company-beacon/modify/:NO`, exact: true, name: '수정', element: <BeaconBoardModify />, ...ADMIN_ACCESS },
    { path: `${PF}/company-mobile`, exact: true, name: '기기변경', element: <MobileBoard />, ...ADMIN_ACCESS },
    { path: `${PF}/company-mobile/modify/:NO`, exact: true, name: '삭제', element: <MobileBoardModify />, ...ADMIN_ACCESS },

]



export default RoutesTerminal;
